import React from "react";
import { Box, Flex } from "@100mslive/roomkit-react";
import { Logo, SpeakerTag } from "./HeaderComponents";
import { ParticipantCount } from "./ParticipantList";
import { StreamActions } from "./StreamActions";

export const ConferencingHeader = ({ isPreview }) => {
  return (
    <Box
      css={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        bg: "$background_dim",
        borderBottom: "1px solid $border_bright",
        w: "100%",
        h: "100%",
      }}
    >
      <Box
        css={{
          mx: "auto",
          maxWidth: "1536px",
          px: "$4",
          py: "$4",
          h: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          "@md": {
            px: "$8",
          },
        }}
      >
        <Flex align="center" css={{ gap: "$8", flex: "0 0 auto" }}>
          <Logo />
          {!isPreview && <SpeakerTag />}
        </Flex>

        <Flex
          align="center"
          css={{
            gap: "$6",
            flex: "0 0 auto",
          }}
        >
          <StreamActions />
          <ParticipantCount />
        </Flex>
      </Box>
    </Box>
  );
};
